<template>
  <div class="row secondary-filter">
    <div class="col-8 filter-grid filter-sort">
      <div class="filter-status">
        <Status :options="status"
        :selected="defaultStatus" v-on:updateOption="onChangeStatus" />
      </div>
    </div>
    <div class="col-4 filter-grid dropdown-section">
      <!-- <ul>
        <li class="dropdown-list">
        <DatePicker
          v-model="orderRange"
          type="daterange"
          align="right"
          format="dd/MMM"
          :editable="editable"
          size="mini"
          start-placeholder="Start Date"
          end-placeholder="End Date"
          @change="filterByDate"
          />
        </li>
      </ul> -->
    </div>
  </div>
</template>

<script>
import options from '@/constants/invoice-status';
import Status from './Status';

export default {

  components: {
    Status,
  },

  data() {
    return {
      editable: false,
      orderRange: null,
    };
  },

  computed: {
    defaultStatus() {
      return this.status[0];
    },
    status() {
      return options;
    },
  },
  methods: {

    onChangeStatus(selected) {
      this.selectedStatus = selected;
      this.$emit('statusChange', selected);
    },

    filterByDate(selected) {
      this.$emit('filterByDate', selected);
    },

  },

};
</script>

<style lang="scss">
@import "~@common/styles-transporter/settings";
.secondary-filter {
    border-top-width: 0;
    padding: 0 ;
    border: 1px solid #DEE5E6;
    background-color: #fff;
    height: 50px;
    margin-left: -20px;
    margin-right: -20px;
    border-top-color: transparent;
    .filter-status {
        width: 205px;
        display: inline-block;
        border-right: 1px solid #DBE4E8;
        vertical-align: middle;
        padding: 9px 0;
        color: #4F5050;
        font-family:$fontSemibold;
        font-size: 14px;
        text-transform: uppercase;
        position: relative;
        top: -2px;
        height: 50px;
        .dropdown-toggle {
            padding: 0 0 0 15px;
        }
        .btn-group {
            min-width: 154px;
        }
    }
    .substatus-group {
        display: inline-block;
        padding: 9px 20px;
        position: relative;
        top: -2px;
        .btn {
            @extend %semi-bold;
        }
    }
    .dropdown-section {
        padding: 0;
        ul {
            @extend %list-unstyled;
            float: right;
        }
        .dropdown-list {
            border-left: 1px solid #DBE4E8;
            padding: 3px 0 5px 20px;
            color: #4F5050;
            font-family:$fontSemibold;
            font-size: 1.4rem;
            height: 50px;
        }
    }
}
</style>
